import NamaCommon from "@/utils/common/NamaCommon";
import {InDevMode} from "@/devmode";

export function modifyJSPrototypes() {
    Array.prototype.binaryContains = function <T>(el: T, compareFn: (a: T, b: T) => number = NamaCommon.defaultCompare): boolean {
        return NamaCommon.binarySearch(this as T[], el, compareFn) >= 0;
    }

    Array.prototype.contains = function (el) {
        return this.indexOf(el) >= 0
    }
    if (InDevMode && window && !window.$) {
        HTMLInputElement.prototype.val = function (v: any) {
            this.value = v;
        }
        window.$ = function (id: string) {
            return document.getElementById(id.substring(1));
        }
    }
}
